export default __webpack_public_path__ + "img/009b963f6e759bdd1313df229526488e.svg";